import React, { useRef } from 'react'
import classes from './AddNote.module.css'
import { Dropdown, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'

const AddNote = (props) => {
    const [t] = useTranslation('common')
    const noteReasonRef = useRef()
    const submitHandler = (e) => {
        e.preventDefault()
        props.onClick(noteReasonRef.current.value)
        noteReasonRef.current.value=''
    }
    return (
        <Dropdown >
            <div onClick={(e) => { e.stopPropagation() }}>
                <Dropdown.Toggle variant='outline-secondary' className={`${classes['add-note-toggel']} ${props.toggleCss ? props.toggleCss : ''}`} >
                    <button className={`${classes['add-note']} ${props.btnCss ? props.btnCss : ''}`} >
                        {props.label && <span>{props.label}</span>}
                        <i className="fa-solid fa-comment-dots" />
                    </button>
                </Dropdown.Toggle>
            </div>
            <Dropdown.Menu className={`${classes["note-container"]}`} onClick={(e) => { e.stopPropagation() }}>

                <form onSubmit={submitHandler}>
                    <div className={classes['note-reason-container']}>
                        {/* <label className={`${classes['note-reason-label']}`} htmlFor='note-reason-textarea'>{t('reason')}</label> */}
                        <label htmlFor='note-reason-textarea' className={`${classes['add-note-title']}`}>{t('Add Note to a forward')}</label>
                        <textarea ref={noteReasonRef} className={`${classes['note-reason-textarea']}`} id='note-reason-textarea' />
                    </div>
                    <Button type='submit' className={classes['action-btn']} variant="success">{t('add')}</Button>
                </form>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default AddNote